import axios from 'axios'
import * as Cache from "../cache/Cache";
import Constant from "../constant/index";

const HTTP_RESP_CODE = {
  RESP_CODE_SUCCESS:200//请求成功
}

//上传图片
export const uploadImage = (imageFile, success= ()=>{}, fail = ()=>{})=>{
  let formData = new FormData();
  formData.append("file",imageFile);
  // let url = process.env.API_HOST + "/attachment/uploadAttachment";
  let url = Constant.UPLOAD_URL;
  let xcSession = Cache.getSsoSession();
  console.log(`【uploadImage】发起请求：`,url);
  axios({
    method: 'post',
    url : url,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
      'xc_sso_sessionid': xcSession
    }
  }).then(res => {
    handleResp(res, success, fail);
  })

}


/** 对返回结果进行处理 */
const handleResp = (resp, success, fail)=>{
  let data = resp.data;
  let status = resp.status;
  if (status === 200) {
    //解密成功
    if (data.code === HTTP_RESP_CODE.RESP_CODE_SUCCESS) {
      //请求服务器成功返回
      success(data);
    } else {
      failCallback(fail, data);
    }

  } else{
    failCallback(fail, createFailRespObj('服务器异常'));
  }
}


const failCallback = (failCallback, resp) => {
  if(resp && resp.respMsg) {
    alert(resp.respMsg);
  }
  if(failCallback) {
    failCallback(resp);
  }
}

const createFailRespObj = (errorMsg) => {
  return {respMsg: errorMsg};
}



// WEBPACK FOOTER //
// ./src/api/UploadAPI.js